import { createSlice } from "@reduxjs/toolkit";
import i18n from "../../translations/i18n";
import { message } from "antd";

const initialState = [];

export const compareSlice = createSlice({
  name: "compare",
  initialState,
  reducers: {
    addToCompareAction: (state, action) => {
      const product = action.payload;
      const compareItem = state.find((item) => item.id === product.id);

      if (compareItem === undefined) {
        state.push(product);
      }
    },
    deleteFromCompareAction: (state, action) => {
      const product = action.payload;
      return state.filter((compareItem) => compareItem.id !== product.id);
    },
  },
});

// Action creators
export const { addToCompareAction, deleteFromCompareAction } =
  compareSlice.actions;

// Thunks
export const addToCompare = (item) => (dispatch) => {
  message.success(i18n.t("added_to_compare"), 1);
  dispatch(addToCompareAction(item));
};

export const deleteFromCompare = (item) => (dispatch) => {
  dispatch(deleteFromCompareAction(item));
};

export default compareSlice.reducer;
